export const LandingSubPageId = 'LandingSubPage';

export enum LandingSubPageAttributes {
  HERO_MEDIA = 'heroMedia',
  HERO_MEDIA_ALT = 'heroMediaAlt',
  HERO_MEDIA_TITLE = 'heroMediaTitle',
}
